var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.value),function(t,i){return _c('p',{key:i},[_vm._v("\n        状态: "+_vm._s(_vm.getStatusName(t.valid))+" "),_c('br'),_vm._v("\n        message: "+_vm._s(t.message)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }